import React from 'react';
import './PageTitle.css';

import { FaAngleDoubleRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';



const PageTitle = (props) => {
 
  // Destructuring props
    const { title, page, heading = '', subTitle = ''} = props; 


  return ( 
    <div className='page-title'>

      {/* Title Container */}
      <div className='title'> 
              <h2>{title}</h2> 
              {heading && <h1 className="main-heading">{heading}</h1>}
              {subTitle && <p className="sub-description">{subTitle}</p>}
      </div> 

      {/* Link and page Container */}
      <div className='link'>
        <Link to='/'>Strona Główna</Link> {/* Link to the home page */}
        <FaAngleDoubleRight className='icon' /> {/* Icon indicating a link */}
        <span className='page'>{page}</span> {/* Page Title */}
      </div>

    </div>
  )
}

export default PageTitle;